var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"gift disFlex fvc vertical"},[_c('div',[_c('div',{staticClass:"disFlex fvc vertical"},[_c('img',{staticClass:"status-img",attrs:{"src":"https://j.weizan.cn/youxiang/check-success.png"}}),_c('div',{staticClass:"check-status"},[_vm._v("信息已提交，待审核")])])])])])
}]

export { render, staticRenderFns }